export const getGender = (gender) => {
  switch (gender) {
    case "male":
    case "Male":
    case "MALE":
    case "M":
    case "m":
      return "Male";
    case "female":
    case "Female":
    case "FEMALE":
    case "F":
    case "f":
      return "Female";
    case "other":
    case "Other":
    case "OTHER":
    case "O":
    case "o":
      return "Other";
    default:
      return "Unknown";
  }
};


export const getAgoTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const now = new Date();
  const diff = now - d;
  if (diff < 0) return "Just now";
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  const weeks = Math.floor(diff / 604800000);
  const months = Math.floor(diff / 2629746000);
  const years = Math.floor(diff / 31556952000);

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  if (weeks < 4) return `${weeks}w ago`;
  if (months < 12) return `${months}mo ago`;
  return `${years}y ago`;
};